import { InformationCircleIcon } from '@heroicons/react/24/outline'

/**
 * How to choose a run budget, wherever one is being chosen.
 *
 * A call-out rather than hint text under the select: this explains how to
 * decide, which is a different job from the per-option hints saying what each
 * one does, and it is the part someone spending money needs to read first.
 */
function ApifyResourcesHelp() {
    return (
        // Ink, not arwen: the reskin made arwen-tinted panels read as alerts
        // (see InfoCallout), and this is guidance, not a warning.
        <div className="rounded-md border border-ink-200 bg-ink-100 p-3 text-sm text-ink-700">
            <div className="flex gap-2">
                <InformationCircleIcon
                    className="h-5 w-5 flex-shrink-0 text-ink-500"
                    aria-hidden="true"
                />
                <div className="space-y-2">
                    <p>
                        Apify scraping resource costs money each time. There are two questions when
                        deciding how much muscle to give a scrape:
                    </p>
                    <ol className="list-decimal list-inside space-y-1">
                        <li>Does this profile get a lot of comments?</li>
                        <li>How far do you want to go back in time?</li>
                    </ol>
                    <p>
                        The most active profiles need more Apify resources, and so do the longest
                        fetches. If you pick High when you don&apos;t need to then you&apos;ll waste
                        money, but if you pick Low then Apify might stop out before it&apos;s
                        collected all the comments.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ApifyResourcesHelp
